import api from '../../utils/axios';
import { useState, useCallback } from 'react';

interface ImpuestoItem {
  Id: number;
  Nombre: string;
  Valor: number;
  Activo: boolean;
  Eliminado: boolean;
}

interface ImpuestoDto {
  Nombre: string;
  Valor: number;
  Activo: boolean;
}

interface ApiError {
  response?: {
    data?: {
      message?: string;
    };
  };
  message: string;
}

const useImpuestosApi = () => {
  const [isLoading, setIsLoading] = useState(false);
  const baseUrl = '/administracion/impuestos';

  const getAll = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await api.post<ImpuestoItem[]>(`${baseUrl}/findAll`);
      return response.data.filter(item => !item.Eliminado);
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const create = useCallback(async (data: ImpuestoDto) => {
    setIsLoading(true);
    try {
      const response = await api.post(`${baseUrl}/create`, data);
      return response.data;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const update = useCallback(async (id: number, data: ImpuestoDto) => {
    setIsLoading(true);
    try {
      const response = await api.post(`${baseUrl}/update/${id}`, data);
      return response.data;
    } catch (err) {
      const error = err as ApiError;
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const remove = useCallback(async (id: number) => {
    setIsLoading(true);
    try {
      const response = await api.post(`${baseUrl}/softDelete/${id}`);
      return true;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    isLoading,
    getAll,
    create,
    update,
    remove
  };
};

export { useImpuestosApi };
export type { ImpuestoItem, ImpuestoDto, ApiError };